export const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? "",
  DEFAULT_LOCALE: import.meta.env.VITE_DEFAULT_LOCALE ?? "en",
} as const;
